module.exports = __webpack_public_path__ + "img/SL7_4804_0-Bearbeitet.13585913.jpg";